import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warning\">\n<g clip-path=\"url(#icon-warning_clip0_4059_4524)\">\n<path d=\"M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z\" stroke=\"currentColor\" stroke-width=\"1.3\" stroke-linecap=\"round\" />\n<path d=\"M7 4.5V7.5M7 9.5H7.01\" stroke=\"currentColor\" stroke-width=\"1.3\" stroke-linecap=\"round\" />\n</g>\n<defs>\n<clipPath id=\"icon-warning_clip0_4059_4524\">\n<rect width=\"14\" height=\"14\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/warning.svg
// module id = +xVY
// module chunks = 258